import { useEffect, useState } from 'react';
import axios from 'axios';

import agua from '../../assets/services/agua.png';
import cocina from '../../assets/services/cocina.png';
import gas from '../../assets/services/gas.png';
import internet from '../../assets/services/internet.png';
import lavanderia from '../../assets/services/lavanderia.png';
import limpieza from '../../assets/services/limpieza.png';
import luz from '../../assets/services/luz.png';
import piscina from '../../assets/services/piscina.png';
import tv from '../../assets/services/tv.png';
import { useParams } from 'react-router-dom';

import { Button, Modal } from 'react-bootstrap';
import MapComponent from '../../components/Map';
import Filters from '../../components/Filters/FiltersHome';

import { useLang } from '../../context/LangContext';

import enTexts from '../../translations/en.json';
import esTexts from '../../translations/es.json';

function ListAccommodations() {
  const [accommodations, setAccommodations] = useState([]);
  const [filteredAccommodations, setFilteredAccommodations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [whatsappGroupUrl, setWhatsappGroupUrl] = useState(null);

  const { lang } = useLang();
  const [texts, setTexts] = useState(lang === 'es' ? esTexts : enTexts);

  const [filterCountry, setFilterCountry] = useState(null);
  const [filterRegion, setFilterRegion] = useState(null);
  const [filterCity, setFilterCity] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currrentTitleModal, setCurrentTitleModal] = useState('');
  const [imagesInModal, setImagesInModal] = useState([]);

  const params = useParams();
  const slug = params['*'] || params.slug;

  const serviceImages = {
    agua,
    cocina,
    gas,
    internet,
    lavanderia,
    limpieza,
    luz,
    piscina,
    tv,
  };

  const handleNext = () => {
    const currentIndex = imagesInModal.findIndex(image => image.url === selectedImage.url);

    if (currentIndex === imagesInModal.length - 1) {
      setSelectedImage(imagesInModal[0]);
    } else {
      setSelectedImage(imagesInModal[currentIndex + 1]);
    }
  };

  const handlePrev = () => {
    const currentIndex = imagesInModal.findIndex(image => image.url === selectedImage.url);

    if (currentIndex === 0) {
      setSelectedImage(imagesInModal[imagesInModal.length - 1]);
    } else {
      setSelectedImage(imagesInModal[currentIndex - 1]);
    }
  };

  const handleCountrySelected = selectedOption => {
    setFilterCountry(selectedOption);
  };
  const handleRegionSelected = selectedOption => {
    setFilterRegion(selectedOption); // Actualiza la variable filterRegion
  };
  const handleCiudadSelected = selectedOption => {
    setFilterCity(selectedOption); // Actualiza la variable filterCity
  };

  const filterAccommodations = () => {
    setIsLoading(true);
    setTimeout(() => {
      let filteredAccommodations = accommodations;

      if (filterCountry) {
        filteredAccommodations = filteredAccommodations.filter(accommodation => {
          const cId =
            accommodation.country_id ||
            (accommodation.city &&
              accommodation.city.region &&
              accommodation.city.region.country &&
              accommodation.city.region.country.id);
          return Number(cId) === Number(filterCountry);
        });
      }

      if (filterRegion) {
        filteredAccommodations = filteredAccommodations.filter(
          accommodation => accommodation.region_id === filterRegion
        );
      }

      if (filterCity) {
        filteredAccommodations = filteredAccommodations.filter(
          accommodation => accommodation.city_id === filterCity
        );
      }

      setFilteredAccommodations(filteredAccommodations);
      setIsLoading(false);
    }, 150);
  };

  const removeTilde = string => {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  const renderStars = rating => {
    const stars = [];
    const r = rating || 5;
    for (let i = 1; i <= 5; i++) {
      if (i <= r) {
        stars.push(<i key={i} className="fa fa-star text-warning me-1"></i>);
      } else if (i === Math.ceil(r) && !Number.isInteger(r)) {
        stars.push(<i key={i} className="fa fa-star-half-o text-warning me-1"></i>);
      } else {
        stars.push(<i key={i} className="fa fa-star-o text-warning me-1"></i>);
      }
    }
    return stars;
  };

  const getAllAccommodations = async () => {
    setIsLoading(true);
    try {
      const endpoint = slug
        ? `/api/${lang}/accommodations/allBySlug/${encodeURIComponent(slug)}`
        : `/api/${lang}/accommodations/all`;
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${endpoint}`);
      setAccommodations(response.data);
    } catch (err) {
      console.error('Error fetching accommodations:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const getWhatsappGroup = async () => {
    if (!slug) {
      setWhatsappGroupUrl(null);
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/destinations`
      );
      const allDests = response.data;
      const currentDest = allDests.find(d => {
        const dSlug =
          d.slug ||
          d.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[\s/]+/g, '-');
        return dSlug === slug || d.slug === slug;
      });
      if (currentDest && currentDest.whatsapp_url) {
        setWhatsappGroupUrl(currentDest.whatsapp_url);
      } else {
        setWhatsappGroupUrl(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageClick = (image, title, images) => {
    setCurrentTitleModal(title);
    setSelectedImage(image);
    setImagesInModal(images);
    setShowModal(true);
  };

  useEffect(() => {
    getAllAccommodations();
    getWhatsappGroup();
  }, []);

  useEffect(() => {
    filterAccommodations();
  }, [filterCountry, filterRegion, filterCity]);

  useEffect(() => {
    getAllAccommodations();
    getWhatsappGroup();
    setTexts(lang === 'es' ? esTexts : enTexts);
  }, [lang]);

  const renderMobileTitle = title => {
    if (!title) return null;
    const prefix = 'Edificio ';
    if (title.startsWith(prefix)) {
      const mainPart = title.substring(prefix.length);
      return (
        <div className="mobile-accommodation-title">
          Edificio <span className="mobile-accommodation-title-bold">{mainPart}</span>
        </div>
      );
    }
    return (
      <div className="mobile-accommodation-title mobile-accommodation-title-bold">{title}</div>
    );
  };

  return (
    <>
      {/* Header Desktop */}
      <div className="d-none d-sm-block">
        <h1 className="text-center text-uppercase my-3">{texts.accommodations.title}</h1>

        {whatsappGroupUrl && (
          <div className="container mt-2 mb-4 text-center">
            <a
              href={whatsappGroupUrl}
              target="_blank"
              rel="noreferrer"
              className="btn btn-success rounded-pill px-4 py-2"
              style={{
                backgroundColor: '#25D366',
                borderColor: '#25D366',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              }}
            >
              <i className="fa fa-whatsapp me-2" style={{ fontSize: '1.2rem' }}></i>
              <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
                {lang === 'en' ? 'Join our WhatsApp Group' : 'Únete a nuestro grupo de WhatsApp'}
              </span>
            </a>
          </div>
        )}
      </div>

      {/* Header Hero Móvil */}
      <div className="mobile-hero-wrapper d-block d-sm-none">
        <div className="mobile-hero-eyebrow">
          {texts.accommodations.hero_eyebrow || 'Encuentra tu hogar en Chile'}
        </div>
        <h1 className="mobile-hero-title">
          {texts.accommodations.title_mobile || 'Opciones de alojamiento'}
        </h1>
        <div className="mobile-hero-subtitle">
          <div>
            {texts.accommodations.hero_desc_1 ||
              'Alojamientos certificados para estudiantes de intercambio.'}
          </div>
          <div>{texts.accommodations.hero_desc_2 || 'Seguros, cómodos y cerca de todo.'}</div>
        </div>
        {whatsappGroupUrl && (
          <a
            href={whatsappGroupUrl}
            target="_blank"
            rel="noreferrer"
            className="mobile-whatsapp-btn"
          >
            <i className="fa fa-whatsapp me-2" style={{ fontSize: '1.25rem' }}></i>
            <span>
              {lang === 'en' ? 'Join our WhatsApp Group' : 'Únete a nuestro grupo de WhatsApp'}
            </span>
          </a>
        )}
      </div>

      <div className="container my-3">
        <div className="col-12 col-lg-10 col-xl-9">
          <Filters
            onCountrySelected={handleCountrySelected}
            onRegionSelected={handleRegionSelected}
            onCiudadSelected={handleCiudadSelected}
            accommodations={accommodations}
          />
        </div>
      </div>

      <div className="container min-vh-50 py-3">
        {isLoading ? (
          <div className="text-center py-5 my-4">
            <div
              className="spinner-border text-secondary"
              role="status"
              style={{ width: '3rem', height: '3rem', borderWidth: '0.25em' }}
            >
              <span className="visually-hidden">
                {lang === 'es' ? 'Cargando alojamientos...' : 'Loading accommodations...'}
              </span>
            </div>
            <div className="text-muted mt-3 fw-semibold" style={{ fontSize: '0.95rem' }}>
              {lang === 'es' ? 'Cargando alojamientos...' : 'Loading accommodations...'}
            </div>
          </div>
        ) : (filterCountry || filterRegion || filterCity ? filteredAccommodations : accommodations)
            .length === 0 ? (
          <div className="text-center py-5 my-4 text-muted">
            <i className="fa fa-home mb-3" style={{ fontSize: '3rem', color: '#cbd5e1' }}></i>
            <h5 className="fw-bold text-secondary">
              {lang === 'es' ? 'No se encontraron alojamientos' : 'No accommodations found'}
            </h5>
            <p className="small">
              {lang === 'es'
                ? 'Prueba modificando o limpiando los filtros seleccionados.'
                : 'Try adjusting or clearing your selected filters.'}
            </p>
          </div>
        ) : (
          (filterCountry || filterRegion || filterCity
            ? filteredAccommodations
            : accommodations
          ).map(accommodation => (
            <div className="row" key={accommodation.id}>
              <div className="col-12 border-bottom my-3 pb-4">
                {/* Encabezado Desktop */}
                <div className="d-none d-sm-block text-start mb-2">
                  <h3>{accommodation.title}</h3>
                  <div className="mb-2">
                    <div>{renderStars(accommodation.rating)}</div>
                    <div className="text-muted" style={{ fontSize: '0.9rem' }}>
                      <i className="fa fa-map-marker me-1"></i>
                      {accommodation.city_name ? `${accommodation.city_name}, ` : ''}
                      {accommodation.country_abbreviation}
                    </div>
                  </div>
                </div>

                {/* Encabezado Móvil */}
                <div className="mobile-accommodation-header d-block d-sm-none">
                  <div className="mobile-accommodation-brand">
                    {texts.accommodations.brand_prefix || 'Santiago Exchange'}
                  </div>
                  {renderMobileTitle(accommodation.title)}
                  <div className="mobile-accommodation-stars">
                    {renderStars(accommodation.rating)}
                  </div>
                  <div className="mobile-accommodation-location">
                    {accommodation.city_name ? `${accommodation.city_name}, ` : 'Santiago, '}
                    {accommodation.country_abbreviation || 'CL'}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div>
                      <img
                        src={accommodation.main_image}
                        alt={accommodation.title}
                        className="img-fluid w-100 border p-1 border-mobile-none p-mobile-0 rounded-top-mobile mb-2 cursor-pointer fix-size-principal"
                        onClick={() =>
                          handleImageClick(
                            {
                              url: accommodation.main_image,
                            },
                            accommodation.title,
                            accommodation.images
                          )
                        }
                      />
                    </div>
                    <div
                      className="row d-none d-sm-flex"
                      style={{ marginLeft: '-5px', marginRight: '-5px' }}
                    >
                      {accommodation.images.slice(0, 5).map(
                        (image, index) =>
                          image.url !== accommodation.main_image && (
                            <div className="col px-1" key={index}>
                              <img
                                src={image.url}
                                alt={`${accommodation.title} ${index}`}
                                className="img-thumb p-1 border w-100 cursor-pointer"
                                onClick={() =>
                                  handleImageClick(image, accommodation.title, accommodation.images)
                                }
                              />
                            </div>
                          )
                      )}
                      {accommodation.images.length > 5 && (
                        <div className="col px-1">
                          <button
                            className="border w-100 img-thumb cursor-pointer"
                            onClick={() =>
                              handleImageClick(
                                accommodation.images[6],
                                accommodation.title,
                                accommodation.images
                              )
                            }
                          >
                            <i className="fa fa-plus" style={{ fontSize: '2rem' }}></i>
                          </button>
                        </div>
                      )}
                    </div>
                    <div
                      className="row d-flex d-sm-none"
                      style={{ marginLeft: '-5px', marginRight: '-5px' }}
                    >
                      {accommodation.images
                        .filter(img => img.url !== accommodation.main_image)
                        .slice(0, 2)
                        .map((image, index) => (
                          <div className="col-6 px-1 position-relative" key={index}>
                            <img
                              src={image.url}
                              alt={`${accommodation.title} ${index}`}
                              className={`img-thumb-mobile w-100 cursor-pointer ${index === 0 ? 'rounded-bl-mobile' : 'rounded-br-mobile'}`}
                              onClick={() =>
                                handleImageClick(image, accommodation.title, accommodation.images)
                              }
                            />
                            {index === 1 && accommodation.images.length > 3 && (
                              <div
                                className="position-absolute d-flex align-items-center justify-content-center cursor-pointer"
                                style={{
                                  bottom: '10px',
                                  left: '10px',
                                  right: '10px',
                                  zIndex: 10,
                                }}
                                onClick={() =>
                                  handleImageClick(
                                    accommodation.images[0],
                                    accommodation.title,
                                    accommodation.images
                                  )
                                }
                              >
                                <div
                                  className="bg-white text-dark rounded-3 px-2 py-1 fw-bold text-center d-flex align-items-center justify-content-center"
                                  style={{
                                    fontSize: '0.75rem',
                                    width: '100%',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                  }}
                                >
                                  <i className="fa fa-clone me-2"></i> VER TODAS LAS FOTOS
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                    {accommodation.map_position && (
                      <div className="mt-2 border d-none d-sm-block">
                        <MapComponent
                          accommodation_id={accommodation.id}
                          map_position={accommodation.map_position}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-sm-6 mt-4 mt-sm-0">
                    <div className="d-none d-sm-block">
                      {/* if description_en or description_es are not emprty */}
                      {(accommodation.description_en != null ||
                        accommodation.description_es != null) && (
                        <>
                          <h5 className="mb-3 text-uppercase title-section">
                            <b>{texts.accommodations.features.description}: </b>
                          </h5>
                          <div className="row mb-5">
                            <div className="col-12">
                              {lang === 'es'
                                ? accommodation.description_es
                                : accommodation.description_en}
                            </div>
                          </div>
                        </>
                      )}

                      <h5 className="mb-3 text-uppercase title-section">
                        <b>{texts.accommodations.features.title}: </b>
                      </h5>
                      <div className="row">
                        <div className="col-6">
                          {texts.accommodations.features.rooms}: {accommodation.rooms}
                        </div>
                        <div className="col-6">
                          {texts.accommodations.features.furnished}:{' '}
                          {accommodation.furnished ? 'Si' : 'No'}
                        </div>
                        <div className="col-6">
                          {texts.accommodations.features.bathrooms}: {accommodation.bathrooms}
                        </div>
                        <div className="col-6">
                          {texts.accommodations.features.nearest_metro}:{' '}
                          {accommodation.closest_subway}
                        </div>
                      </div>
                    </div>

                    <div className="d-none d-sm-block">
                      <h5 className="mt-5 mb-3 text-uppercase title-section">
                        <b>{texts.accommodations.services.title}: </b>
                      </h5>
                      <div className="row">
                        {Object.keys(accommodation.services)
                          .filter(service => accommodation.services[service])
                          .map(service => (
                            <div className="col-4 my-1" key={service}>
                              <img
                                src={serviceImages[removeTilde(service)]}
                                alt={service}
                                className="service-icon me-2"
                              />
                              {texts.accommodations.services[service]}
                            </div>
                          ))}
                      </div>
                    </div>

                    <div className="d-block d-sm-none">
                      <h3 className="mt-4 mb-4 text-center" style={{ fontWeight: 'normal' }}>
                        {lang === 'es' ? (
                          <>
                            Servicios <b>incluídos</b>
                          </>
                        ) : (
                          <>
                            Included <b>services</b>
                          </>
                        )}
                      </h3>
                      <div className="row">
                        {Object.keys(accommodation.services)
                          .filter(service => accommodation.services[service])
                          .map(service => (
                            <div className="col-3 my-2 px-1 text-center" key={service}>
                              <div>
                                <img
                                  src={serviceImages[removeTilde(service)]}
                                  alt={service}
                                  className="service-icon mb-2"
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    objectFit: 'contain',
                                  }}
                                />
                              </div>
                              <div style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>
                                {texts.accommodations.services[service]}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>

                    <div className="d-none d-sm-block">
                      <div>
                        <h5 className="mt-5 mb-3 text-uppercase title-section">
                          <b>{texts.accommodations.contact.title}</b>
                        </h5>
                        <div>
                          {texts.accommodations.contact.name}: {accommodation.contact.name}
                        </div>
                        <div>
                          {texts.accommodations.contact.address}: {accommodation.contact.address}
                        </div>
                        <div>
                          {texts.accommodations.contact.phone}: {accommodation.contact.phone}
                        </div>
                        <div>
                          {texts.accommodations.contact.email}: {accommodation.contact.email}
                        </div>
                      </div>
                      <div className="mt-4 tcenter">
                        {accommodation.social_networks.facebook && (
                          <a
                            href={`https://web.facebook.com/${accommodation.social_networks.facebook}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-facebook bg-dark text-white p-2 text-center rounded-circle rrss-icon me-2"></i>
                          </a>
                        )}
                        {accommodation.social_networks.instagram && (
                          <a
                            href={`https://www.instagram.com/${accommodation.social_networks.instagram}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-instagram bg-dark text-white p-2 text-center rounded-circle rrss-icon me-2"></i>
                          </a>
                        )}
                        {accommodation.social_networks.whatsapp && (
                          <a
                            href={`https://api.whatsapp.com/send?phone=${accommodation.social_networks.whatsapp}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-whatsapp bg-dark text-white p-2 text-center rounded-circle rrss-icon me-0 me-sm-5"></i>
                          </a>
                        )}
                        {accommodation.website && (
                          <>
                            <a href={accommodation.website} target="_blank" rel="noreferrer">
                              <button className="btn btn-dark rounded-0 text-uppercase px-5">
                                {texts.accommodations.contact.visit_website}
                              </button>
                            </a>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="d-block d-sm-none">
                      <div className="bg-sen text-white p-4 rounded-4 text-center text-md-start mb-4 mt-5">
                        <h4 className="mb-3 text-center">{texts.accommodations.contact.title}</h4>
                        <div className="mb-2">
                          <span className="me-md-3 d-block d-md-inline">
                            {texts.accommodations.contact.name}: {accommodation.contact.name}
                          </span>
                          <span className="d-block d-md-inline">
                            {texts.accommodations.contact.address}: {accommodation.contact.address}
                          </span>
                        </div>
                        <div className="mb-2">
                          <span className="me-md-3 d-block d-md-inline">
                            {texts.accommodations.contact.phone}: {accommodation.contact.phone}
                          </span>
                          <span className="d-block d-md-inline">
                            {texts.accommodations.contact.email}: {accommodation.contact.email}
                          </span>
                        </div>
                        {accommodation.website && (
                          <>
                            <div className="mb-4">
                              <span className="d-block d-md-inline">
                                Web: {accommodation.website.replace(/^https?:\/\//, '')}
                              </span>
                            </div>
                            <div className="text-center">
                              <a href={accommodation.website} target="_blank" rel="noreferrer">
                                <button className="btn btn-dark text-uppercase px-4 py-2 fw-bold rounded-2">
                                  {texts.accommodations.contact.visit_website}
                                </button>
                              </a>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="mt-4 text-center">
                        {accommodation.social_networks.facebook && (
                          <a
                            href={`https://web.facebook.com/${accommodation.social_networks.facebook}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i
                              className="fa fa-facebook bg-dark text-white p-2 text-center rounded-3 rrss-icon mx-2"
                              style={{
                                fontSize: '1.5rem',
                                width: '45px',
                                height: '45px',
                                lineHeight: '1.2',
                              }}
                            ></i>
                          </a>
                        )}
                        {accommodation.social_networks.instagram && (
                          <a
                            href={`https://www.instagram.com/${accommodation.social_networks.instagram}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i
                              className="fa fa-instagram bg-dark text-white p-2 text-center rounded-3 rrss-icon mx-2"
                              style={{
                                fontSize: '1.5rem',
                                width: '45px',
                                height: '45px',
                                lineHeight: '1.2',
                              }}
                            ></i>
                          </a>
                        )}
                        {accommodation.social_networks.whatsapp && (
                          <a
                            href={`https://api.whatsapp.com/send?phone=${accommodation.social_networks.whatsapp}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i
                              className="fa fa-whatsapp bg-dark text-white p-2 text-center rounded-3 rrss-icon mx-2"
                              style={{
                                fontSize: '1.5rem',
                                width: '45px',
                                height: '45px',
                                lineHeight: '1.2',
                              }}
                            ></i>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{currrentTitleModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedImage && (
            <img
              src={selectedImage.url}
              alt="Imagen en tamaño completo"
              className="img-fluid fix-size"
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button variant="primary" onClick={handlePrev}>
              <i className="fa fa-arrow-left me-1"></i>
              {texts.accommodations.previous}
            </Button>
            <Button variant="primary" onClick={handleNext}>
              {texts.accommodations.next}
              <i className="fa fa-arrow-right ms-1"></i>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ListAccommodations;
